import { useEffect, useState } from 'react';
import { RoomView } from './Room';
import { DiscordMark, Voice } from './icons';

interface Me {
  id: string;
  name: string;
  avatar: string | null;
}

interface RoomInfo {
  id: string;
  name: string;
  count: number;
  joinable: boolean;
}

export function App() {
  // Rota unica: /r/<channelId>. Nao vale a pena um router inteiro para isso.
  const match = /^\/r\/(\d{17,20})$/.exec(location.pathname);
  if (match) return <RoomView channelId={match[1]} />;
  return <Home />;
}

function Home() {
  const [me, setMe] = useState<Me | null | 'loading'>('loading');
  const [rooms, setRooms] = useState<RoomInfo[]>([]);

  useEffect(() => {
    void (async () => {
      const res = await fetch('/api/me');
      if (!res.ok) {
        setMe(null);
        return;
      }
      setMe((await res.json()) as Me);
    })();
  }, []);

  useEffect(() => {
    if (!me || me === 'loading') return;
    const load = async () => {
      const res = await fetch('/api/rooms');
      if (res.ok) setRooms((await res.json()) as RoomInfo[]);
    };
    void load();
    // Os canais enchem e esvaziam o tempo todo; 5s mantem a lista honesta.
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, [me]);

  if (me === 'loading') {
    return (
      <div className="centered">
        <p className="empty-text">Carregando&hellip;</p>
      </div>
    );
  }

  if (!me) {
    return (
      <div className="centered">
        <div className="login">
          <h1 className="login-title">Tela</h1>
          <p className="empty-text">Compartilhamento de tela do grupo.</p>
        </div>
        <a className="btn btn-primary btn-lg" href="/auth/discord?to=/">
          <DiscordMark size={18} />
          Entrar com Discord
        </a>
      </div>
    );
  }

  return (
    <div className="home">
      <header className="topbar">
        <div className="topbar-title">
          <span className="topbar-name">Tela</span>
        </div>
        <span className="topbar-meta">{me.name}</span>
      </header>

      <div className="centered">
        {rooms.length === 0 ? (
          <>
            <h2 className="empty-title">Nenhum canal de voz ocupado</h2>
            <p className="empty-text">
              Entre em um canal de voz no Discord, ou digite <strong>/tela</strong> por la.
            </p>
          </>
        ) : (
          <ul className="rooms">
            {rooms.map((r) => (
              <li key={r.id}>
                <div className="room-info">
                  <Voice size={18} />
                  <span className="room-name">{r.name}</span>
                  <span className="room-count">
                    {r.count} {r.count === 1 ? 'pessoa' : 'pessoas'}
                  </span>
                </div>
                {r.joinable ? (
                  <a className="btn btn-primary" href={`/r/${r.id}`}>
                    Abrir
                  </a>
                ) : (
                  <span className="room-count">entre nesse canal</span>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
